import styled from 'styled-components';

import { HTMLAttributes } from 'react';

export const StyledImage = styled.img<
    { $maxWidth?: number; $center: boolean; $mb?: number } & HTMLAttributes<HTMLImageElement>
>`
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}px;`}
    ${({ $center }) => $center && 'margin-left: auto; margin-right: auto;'}
    ${({ $mb }) => $mb && `margin-bottom: ${$mb}px;`};
`;
